import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../../framework/entity/report/report-page/abstract-report-page";
import {EmployeeTimeCardReportModel} from "./employee-time-card-report.model";

@Component({
    selector: "wbo-employee-time-card-report-page",
    templateUrl: "./employee-time-card-report-page.component.html",
    providers: [provideReportModel(EmployeeTimeCardReportModel)]
})
export class EmployeeTimeCardReportPageComponent extends AbstractReportPage {

    constructor(public model: EmployeeTimeCardReportModel) {
        super();
    }
}
